<template>
  <v-container fluid class="pa-5 pl-10">
    <vue-headful title="Wartung" description="Online-Service Administration"/>
    <v-row>
      <v-col>
        <div class="pb-3">
          <h1 class="display-1" style="color:#d30228;">Wartung</h1>
        </div>
      </v-col>
    </v-row>
    <v-row class="mb-5">
      <v-switch class="ml-3" hide-details v-model="maintenance"></v-switch>
      <div class="ml-3 mt-5">
        Wartungsmodus ist {{maintenance ? 'EIN' : 'AUS'}}.
        <span class="body-2 ml-5">Achtung: im Wartungsmodus, können normale Benutzer nicht mehr einloggen und alle Funktionen, die von der Postgre abhängen werden nicht ausgeführt.</span>
      </div>
    </v-row>
    <v-divider></v-divider>
    <v-row class="pl-3 mt-5">
      <v-btn color="primary" dark :href="dump_url()" download="db_dump.json">
        DB Backup Download
      </v-btn>
      <v-btn class="ml-3" color="primary" dark @click="show_drop_pad=true">
        DB Backup einspielen
      </v-btn>
      <v-btn class="ml-3" color="black" dark @click="onResetDB">
        DB LÖSCHEN
      </v-btn>
    </v-row>
    <v-row>
      <upload-file v-if="show_drop_pad" @upload="onUpload"></upload-file>
    </v-row>
  </v-container>
</template>

<script>
  import UploadFile from "../components/UploadFile";
  export default {
    name: 'Maintenance',
    components: {UploadFile},
    data() {
      return {
        show_drop_pad:false,
        maintenance:false,
        dont_update:false,
      }
    },
    mounted() {
      this.$backend.get_maintenance_mode({no_notify:true, onSuccess:(mode)=> {
          this.dont_update=true;
          this.maintenance=mode;
          this.dont_update=false;
        }});
    },
    methods: {
      dump_url(){
        return '/api/db_dump?token='+this.$store.state.token;
      },
      onUpload(file) {
        console.log("got file:", file);
        this.$backend.db_import(file.data, {onSuccess:()=> {
            file.loading=false;
            this.show_drop_pad=false;
          }});
      },
      onResetDB() {
        this.$events.$emit("ask", {
          title: 'Achtung!!',
          question: 'Dies löscht sämtliche Daten <b>inklusive Benutzerkonten</b>! Sie könnten dabei ihre Admin-Rechte verlieren ' +
            'und wären dann selbst nicht mehr in der Lage ein Backup einzuspielen, sofern es eines gibt.<br><br>' +
            'Diese Operation sollte nur von einem Entwickler durchgeführt werden.',
          //options: [`Komplette Serie (${len})`, `Vorangehende Zahlungen (${index + 1})`, `Folgende Zahlungen (${len - index})`],
          yes_button: 'DB Löschen',
          cancel_button: 'Abbrechen',
          onYes: this.onResetYes,
          //onCancel: (info) => {},
        });
      },
      onResetYes(info) {
        this.$backend.db_reset();
      },
    },
    computed: {
    },
    watch: {
      maintenance(n,o) {
        if (this.dont_update)
          return;
        this.$backend.set_maintenance_mode(n, {onSuccess:(mode)=>{
          this.dont_update=true;
          this.maintenance=mode;
          this.$events.$emit("check_maintenance");
          this.dont_update=false;
        }});
      }
    }
  }
</script>
